///<amd-module name="typeahead/client/HotelSearchResultsPageHandler" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

interface ISubmitData {
    query: string;
    isValid: boolean;
}

export class HotelSearchResultsPageHandler implements IClientHandler {
    private static readonly APPLICABLE_CLIENT_ID = "Hotels.Search";
    private static readonly SEARCH_WIZARD_OPENED_MESSAGE = "toggle.opened";
    private static readonly SEARCH_WIZARD_TOGGLE_BUTTON_ID = "changeSearchWizard";
    /* HSRP publishes certain messages in an order during submit. "hsr.submit.showErrors" is published after client
        validation. The subscriber of this message can read the isValid property from the 'submitObject' which is also
        part of the message and perform certain operations based on the value of this flag.
    */
    private static readonly HSR_SUBMIT_SHOW_ERRORS_MESSAGE = "hsr.submit.showErrors";
    /* "hsr.submit.getQuery" is published during submit by HSRP after "hsr.submit.showErrors" if isValid flag in
     'submitObject' is true. The subscriber of this message in HSRP reads all the form elements and creates the request
     query. This query is set into the 'query' property in the submitObject.
     */
    private static readonly HSR_SUBMIT_GET_QUERY_MESSAGE = "hsr.submit.getQuery";

    private latLong: string;

    public isApplicable(clientId: string): boolean {
        return HotelSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
        let that = this;

        $("form").on("click", "button[type=submit]", (event) => {
            if ($(event.target).parents("form:has(input[data-provide=utypeahead])").length > 0) {
                let rfrrIdPrefix = $(event.target).data("track"); // rfrrIdPrefix=HOT.SR.UpdateSearch
                rfrrIdPrefix = rfrrIdPrefix.match(/(\w+).(\w+)/g)[0] + "|" + rfrrIdPrefix.match(/(\w+).(\w+)/g)[1];
                // rfrrIdPrefix=HOT.SR|UpdateSearch
                $(event.target).removeAttr("data-track");

                ClientHandlerRegistry.publishSubmitClickedMessage(rfrrIdPrefix);
            }
        });

        uitk.subscribe(HotelSearchResultsPageHandler.HSR_SUBMIT_SHOW_ERRORS_MESSAGE,
            (topic: string, submitObject: ISubmitData) => {
            ClientHandlerRegistry.publishFormSubmittedMessage(submitObject.isValid);
        });

        uitk.subscribe(HotelSearchResultsPageHandler.HSR_SUBMIT_GET_QUERY_MESSAGE,
            (topic: string, submitObject: ISubmitData) => {
            this.setLatLongForCurrentLocation(submitObject);
        });
    }

    public subscribeFormLoadedEvent(): void {
        uitk.subscribe(HotelSearchResultsPageHandler.SEARCH_WIZARD_OPENED_MESSAGE,
            (message: string, $target: JQuery) => {
            if (HotelSearchResultsPageHandler.SEARCH_WIZARD_TOGGLE_BUTTON_ID === $target.attr("id")) {
                TypeaheadMessage.publish(new FormLoadedMessage(undefined));
            }
        });
    }

    public getTab(): string {
        return undefined;
    }

    private setLatLongForCurrentLocation(submitObject: ISubmitData) {
        let latLong: string = this.getLatLongFromUrl();
        if (this.isDestinationCurrentLocation() && latLong) {
            $("#latLong").val(latLong);
            if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                submitObject.query += "&latLong=" + latLong;
            }
        }
    }

    private getLatLongFromUrl(): string {
        let sanitize = (latLong: string): string => {
            return (latLong && latLong.match(/^[+-]?\d+\.\d+,[+-]?\d+\.\d+$/)) ? latLong : undefined;
        };
        return sanitize(this.getRequestParameterValue("latLong"));
    }

    private isDestinationCurrentLocation(): boolean {
        let compareAndSanitize = (destination: string): boolean => {
            if (destination) {
                destination = destination.replace(/\+/g, " ");
                return (loc.geolocationDisplayText === $("#inpSearchNear").val() &&
                    loc.geolocationDisplayText ===  destination);
            }
            return false;
        };
        return compareAndSanitize(this.getRequestParameterValue("destination"));
    }

    private getRequestParameterValue(parameter: string): string {
        let result = new RegExp(parameter + "=([^&]*)&?").exec(decodeURIComponent(window.location.href));
        if (result && result.length && result[1]) {
            return result[1];
        }
        return undefined;
    }
}
